import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'buttonText',
	pure: false,
})
export class ButtonTextPipe implements PipeTransform {
	transform(textObject: { main: string; sub: string }): string {
		let msg = textObject.main;
		if (textObject.sub) {
			msg += ` - ${textObject.sub}`;
		}
		return msg;
	}
}
